/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Listen_Go_SubtitleInputs */

const en_onboarding_listen_go_subtitle = /** @type {(inputs: Onboarding_Listen_Go_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(select all that apply)`)
};

const es_onboarding_listen_go_subtitle = /** @type {(inputs: Onboarding_Listen_Go_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(selecciona todas las que apliquen)`)
};

/**
* | output |
* | --- |
* | "(select all that apply)" |
*
* @param {Onboarding_Listen_Go_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_listen_go_subtitle = /** @type {((inputs?: Onboarding_Listen_Go_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Listen_Go_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_listen_go_subtitle(inputs)
	return en_onboarding_listen_go_subtitle(inputs)
});